module.exports = "<svg style=\"width: 12px; height: 12px\" viewBox=\"2 2 12 12\" style=\"width: 12px; height: 12px;\"><path d=\"M9,7 L9,2 L7,2 L7,7 L2,7 L2,9 L7,9 L7,14 L9,14 L9,9 L14,9 L14,7 L9,7 Z\" id=\"path-1\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./assets/icons/plus.svg
// module id = 66
// module chunks = 0